module.exports = __webpack_public_path__ + "static/media/main-bg.f270732c.png";